import { useMutation, useQueryClient } from 'react-query'

import { mediaEntityUploadService } from 'src/services/media-entity-upload.service'
import { QUERY_KEYS } from 'src/constants'
import { scanToEarnService } from 'src/services/scan-to-earn.service'

import { IScanToEarnCreateAccountOrProductDto } from 'src/types'

export const useCreateAIAccountAndProduct = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async (dto: IScanToEarnCreateAccountOrProductDto) => {
      return scanToEarnService.createAIAccountAndProduct(dto)
    },
    {
      onSuccess(data) {
        if (!data) {
          return
        }

        queryClient.invalidateQueries(QUERY_KEYS.CONSUMER_SCANS)
      },
    },
  )
}
